module.exports = __webpack_public_path__ + "static/media/1.049b867b.jpg";